import React from "react";
import { Outlet } from "react-router-dom";
import ADHeader from "./utils/ADHeader";
import LargeScreenNav from "./utils/LargeScreenNav";
import siteLogo from "../assets/dctlogo.png";

export default function ADRoot() {
	const content = (
		<main className="  lg:flex lg:flex-row-reverse  lg:justify-end    lg:items-start  ">
			<section className=" min-w-full    mx-auto">
				<ADHeader />
				<section className="lg:w-[80%]  lg:ml-auto ">
					<Outlet />
				</section>
			</section>
			<section className="hidden  lg:block ">
				<LargeScreenNav siteLogo={siteLogo} />
			</section>
		</main>
	);

	return content;
}
